<template>
  <article class="signed-out-page" aria-labelledby="signed-out-title">
    <p class="screen-kicker">会话已关闭</p>
    <h1 id="signed-out-title">已安全退出</h1>
    <p>本机中的后台权限、查询缓存和敏感页面数据已清除。</p>
    <a class="reauthenticate-link" href="/login">重新登录</a>
  </article>
</template>
